import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Logo = ({ compact = false }) => (
    <a href="#top" className="flex items-center gap-3 group" data-testid="logo-home-link">
        <svg viewBox="0 0 64 64" className="h-10 w-10 shrink-0" aria-hidden="true">
            <rect width="64" height="64" rx="14" fill="#0B261D" stroke="#D4AF37" strokeOpacity="0.5" />
            <g stroke="#D4AF37" strokeWidth="3" strokeLinecap="round">
                <path d="M32 11v42" />
                <path d="M11 32h42" />
                <path d="M17 17l30 30" />
                <path d="M47 17L17 47" />
            </g>
            <circle cx="32" cy="32" r="5.5" fill="#C41E3A" stroke="#F3E5AB" strokeWidth="1.5" />
        </svg>
        {!compact && (
            <span className="hidden leading-tight sm:block">
                <span className="block font-serif text-lg font-bold tracking-tight text-cream">
                    Essex Photography Studio
                </span>
                <span className="block font-mono text-[10px] uppercase tracking-[0.3em] text-gold">
                    Christmas Sessions · Wickford
                </span>
            </span>
        )}
    </a>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
    <span className={`block overflow-hidden ${className}`}>
        <motion.span
            className="block"
            initial={{ y: "112%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.05, delay, ease: EASE }}
        >
            {children}
        </motion.span>
    </span>
);

export const Reveal = ({ children, delay = 0, y = 32, className = "", ...rest }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.85, delay, ease: EASE }}
        {...rest}
    >
        {children}
    </motion.div>
);

export const GoldButton = ({ href, children, className = "", testId }) => (
    <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={testId}
        className={`group relative inline-flex items-center justify-center gap-2 overflow-hidden rounded-full bg-gold px-8 py-4 text-sm font-bold uppercase tracking-[0.14em] text-pine-950 transition-transform duration-300 hover:-translate-y-0.5 hover:shadow-[0_16px_40px_rgba(212,175,55,0.35)] ${className}`}
    >
        <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent transition-transform duration-700 group-hover:translate-x-full" />
        {children}
    </a>
);

export const GhostButton = ({ href, children, className = "", testId, ...rest }) => (
    <a
        href={href}
        data-testid={testId}
        className={`inline-flex items-center justify-center gap-2 rounded-full border border-gold/40 px-8 py-4 text-sm font-semibold uppercase tracking-[0.14em] text-gold-light transition-colors duration-300 hover:border-gold hover:bg-gold/10 ${className}`}
        {...rest}
    >
        {children}
    </a>
);

export const SectionHeading = ({ eyebrow, title, sub, align = "left" }) => (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
        <Reveal>
            <p className="flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.32em] text-gold sm:text-xs">
                {align === "center" && <span className="h-px flex-1 bg-gold/30" />}
                {eyebrow}
                {align === "center" ? <span className="h-px flex-1 bg-gold/30" /> : <span className="h-px w-16 bg-gold/40" />}
            </p>
        </Reveal>
        <Reveal delay={0.08}>
            <h2 className="mt-5 font-serif text-3xl font-bold leading-[1.08] tracking-tight text-cream sm:text-4xl lg:text-5xl">
                {title}
            </h2>
        </Reveal>
        {sub && (
            <Reveal delay={0.16}>
                <p className="mt-5 text-base leading-relaxed text-mist sm:text-lg">{sub}</p>
            </Reveal>
        )}
    </div>
);
